import React, { useEffect, useState } from 'react';
import LegalPage from './LegalPage';

// Правовой документ, загружаемый из public/legal/*.json.
//
// 🔴 Почему запросом, а не импортом. Динамический import() вынести документ из
// сборки НЕ может: измерено 04.09.2026 — webpack режет код по графу модулей до
// минификации, чанк создаётся всегда, и файл с ИНН лежит у клиента на диске, даже
// когда страница недостижима. `public/` же копируется как есть: не положили файл —
// его нет. Документ при этом остаётся статикой, отдаётся тем же nginx и не требует
// ни токена, ни бэкенда.
//
// Источник правды — по-прежнему src/lib/legal/*.js; JSON генерируется из них
// (`npm run legal:gen`; то же делают `prebuild` и `pretest`, поэтому
// разойтись они не могут).
// Прочитанные документы. Страница приходит готовым HTML (scripts/prerender.js),
// и приложение рисует поверх; без текста на первом кадре она мигала бы пустотой
// и сбрасывала прокрутку. index.js дочитывает документ до рендера — preloadLegal.
// Отказ не запоминается: страница попробует сама и покажет свою ошибку.
const loaded = {};

export function preloadLegal(src) {
  if (loaded[src]) return Promise.resolve(loaded[src]);
  return fetch(src)
    .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
    .then((d) => { loaded[src] = d; return d; });
}

export default function LegalDocument({ src }) {
  const [doc, setDoc] = useState(() => loaded[src] || null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (loaded[src]) return undefined;
    let alive = true;
    preloadLegal(src)
      .then((d) => { if (alive) setDoc(d); })
      .catch(() => { if (alive) setFailed(true); });
    return () => { alive = false; };
  }, [src]);

  // Документ не приехал — говорим прямо. Молчаливая пустая страница на месте оферты
  // хуже всего: человек решит, что документа нет, а модератор ЮKassa — что его нет
  // на сайте.
  if (failed) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-16 text-paper-ink-2">
        <p data-testid="legal-failed">
          Документ временно недоступен. Обновите страницу или напишите нам.
        </p>
      </div>
    );
  }
  if (!doc) return <div className="py-16" />;

  return (
    <LegalPage
      title={doc.title}
      date={doc.date}
      sections={doc.sections}
      requisites={doc.requisites}
      requisitesTitle={doc.requisitesTitle}
    />
  );
}
